// addPatientReducer.ts

import { Patient } from '@dataTypes/PatientInfo.types'
import { defaultPatientData } from '@components/layout/Modals/AddPatientModal/patientDataDefaults'

export type ActionType =
  | { type: 'SET_FIELD'; field: keyof Patient; value: any }
  | { type: 'SET_ERRORS'; errors: { [key: string]: string } }
  | { type: 'CLEAR_ERRORS' }
  | { type: 'RESET'; payload: Patient }
  | { type: 'ADD_FILE'; files: File[] }
  | { type: 'DELETE_FILE'; index: number }

export type State = {
  patientData: Patient
  validationErrors: { [key: string]: string }
}

export const initialState: State = {
  patientData: defaultPatientData,
  validationErrors: {},
}

export const reducer = (state: State, action: ActionType): State => {
  switch (action.type) {
    case 'SET_FIELD':
      return {
        ...state,
        patientData: {
          ...state.patientData,
          [action.field]: action.value,
        },
        validationErrors: {
          ...state.validationErrors,
          [action.field]: '',
        },
      }
    case 'SET_ERRORS':
      return {
        ...state,
        validationErrors: action.errors,
      }
    case 'CLEAR_ERRORS':
      return {
        ...state,
        validationErrors: {},
      }
    case 'RESET':
      return {
        ...state,
        patientData: action.payload,
        validationErrors: {},
      }
    case 'ADD_FILE':
      return {
        ...state,
        patientData: {
          ...state.patientData,
          uploadedFiles: [...state.patientData.uploadedFiles, ...action.files],
        },
      }
    case 'DELETE_FILE':
      return {
        ...state,
        patientData: {
          ...state.patientData,
          uploadedFiles: state.patientData.uploadedFiles.filter(
            (_, i: number) => i !== action.index, // Explicitly define the type of `i` and `_`
          ),
        },
      }
    default:
      return state
  }
}
